"use strict";

function addTimestamp(events) {
  return events.map(function (event) {
    return Object.assign({}, event, { timeSaved: Date.now() });
  });
}

module.exports = {
  addTimestamp: addTimestamp
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-beacon/utils/add-timestamp.js
// module id = 1779
// module chunks = 0 1